<template>
  <div :style="wrapStyle">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <cBaseRepeatedlyDialog v-model="isShow" @close="isShow = false">
      <template slot="c-base-bind-game">
        <div :class="getCss('action-bind-game-pop')">
          <p :class="getCss('bind-action-game-title')">获奖提示</p>
          <div :class="getCss('bind-action-pop-area')">
            <div :class="getCss('bind-role-msg')">{{ packageName }}</div>
            <div
              :class="getCss(['action-item-btn-access', 'action-item-btn'])"
              @click="isShow = false"
            >
              我知道了
            </div>
          </div>
        </div>
      </template>
    </cBaseRepeatedlyDialog>
    <!-- 抽奖动效弹框 -->
    <c-base-dialog
      v-model="isShowDynamicEffectDialog"
      :option="effectOption"
      @close="closeDialogBtnClick"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('pop-effect')">
          <div :class="getCss('title')" :style="titleImg"></div>
          <div :class="getCss('pop-effect-animated')">
            <div
              v-show="packageImgArr.length > 1 && showImage"
              :class="getCss('pop-effect-sports_v')"
            >
              <img
                :class="getCss(['card', 'sports-img', 'delay600', animated])"
                v-for="(item, index) in packageImgArr"
                :key="index"
                :src="item.img"
              />
            </div>
            <div
              v-show="packageImgArr.length === 1 && showImage"
              :class="getCss('pop-effect-sports_v')"
            >
              <img
                :class="
                  getCss([
                    'card',
                    'sports-img',
                    'delay600',
                    'only-one-img',
                    animated,
                  ])
                "
                v-for="(item, index) in packageImgArr"
                :key="index"
                :src="item.img"
              />
            </div>
            <div v-show="!showImage" :class="getCss('pop-effect-sports_v')">
              <div :class="getCss('load8')">
                <div :class="getCss(['load8-container', 'container1'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
                <div :class="getCss(['load8-container', 'container2'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
                <div :class="getCss(['load8-container', 'container3'])">
                  <div :class="getCss('circle1')"></div>
                  <div :class="getCss('circle2')"></div>
                  <div :class="getCss('circle3')"></div>
                  <div :class="getCss('circle4')"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="
              getCss([
                'btn-box',
                surplusLotteryTimes < 1 ? 'btn-box-center' : '',
              ])
            "
          >
            <a
              href="javascript:;"
              v-if="surplusLotteryTimes >= 1"
              :class="getCss(['btns', 'btn-once'])"
              :style="onceImg"
              @click="lotteryHandlerFunc(false)"
            ></a>

            <a
              href="javascript:;"
              v-if="surplusLotteryTimes > 1"
              :class="getCss(['btns', 'btn-times'])"
              :style="timesImg"
              @click="lotteryHandlerFunc(true)"
            ></a>

            <a
              href="javascript:;"
              :class="getCss(['btns', 'btn-sure'])"
              @click="closeDialogBtnClick"
              :style="sureImg"
            ></a>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import { componentBaseMixin } from "@tencent/ceiba-base-components";
import button from "@tencent/ceiba-act-public-button";
import CDialog from "@tencent/ceiba-base-components/src/components/base-dialog";
import cBaseRepeatedlyDialog from "./c-base-repeatedly-dialog.vue";
export default {
  name: "CTgclubRepeatedlyLottery",
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    cBaseRepeatedlyDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: "tgclub-repeatedly-lottery-",
      packageName: "",
      isShow: false,
      showImage: false,
      isShowDynamicEffectDialog: false, // 弹框展示与否
      packageImgArr: [], // 活动奖励图片列表
      surplusLotteryTimes: 0, // 剩余抽奖次数
      onceOrtimesFlag: true, // 一次或多次抽奖数量控制变量
      count: 0,
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: "温馨提示",
        fotter: false,
      });
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    computedStyle() {
      // return {
      //   backgroundImage: `url(${this.configurationData.rewardImg})`,
      // };

      if (this.enable) {
        return {
          backgroundImage: `url(${encodeURI(
            this.configurationData.rewardImg
          )})`,
        };
      }
      return {
        backgroundImage: `url(${encodeURI(
          this.configurationData.rewardedImg
        )})`,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return false;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.surplusLotteryTimes = packageStatus.remain;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    effectOption() {
      return Object.assign({}, this.dialogConfig, {
        cancel: false,
        footer: false,
        header: false,
        confirm: false,
        close: true,
        height: "9.2rem",
        width: "7.2rem",
      });
    },
    titleImg() {
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.titleImg)})`,
      };
    },
    onceImg() {
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.onceImg)})`,
      };
    },
    timesImg() {
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.timesImg)})`,
      };
    },
    sureImg() {
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.sureImg)})`,
      };
    },
    animated() {
      return this.configurationData.animationStyle;
    },
  },
  async mounted() {
    console.log("configurationData=", this.configurationData);
    await this.initialize();
  },
  methods: {
    initialize() {
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
    },
    closeBtnClick() {
      this.isShow = false;
    },
    async doReward() {
      this.packageName = ""; // 置空
      // 选择动效弹框时第一次是否单抽，当第一次点击配置为单抽且动效弹框未出现
      if (this.configurationData.onceFlag && !this.isShowDynamicEffectDialog) {
        this.onceOrtimesFlag = false;
      }
      const num = parseInt(
        this.onceOrtimesFlag ? this.configurationData.lotteryNum : 1,
        10
      );
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            pNum: num,
          }),
        },
      });
      this.refreshQua(); // 刷新礼包
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      if (response.ret !== 0) {
        this.alert(response.data.msg || response.msg);
      } else if (response.ret === 0) {
        let { data } = response;
        if (typeof data == "string") {
          data = JSON.parse(data);
        }
        if (data.packageName && num >= 1) {
          let packageId = data.packageId.split(",");
          const packageName = data.packageName.split(",");
          if (packageName.length >= 1) {
            packageId = packageId.map(
              (item) => Number(item.split(":")[1]) || 0
            );
            packageName.forEach((el, index) => {
              if (packageId[index]) {
                packageName[index] = `${el} ${packageId[index]}个`;
              }
            });
            this.packageName = `恭喜您获得了礼包：${packageName.join(",")}`;
          }
        } else {
          this.packageName = response.msg;
        }
        if (data.ret === 0) {
          this.reportFunc('lottery', { status: '1' });
          // 动效弹框
          if (
            this.configurationData.animationStyle
            && this.configurationData.animationStyle !== 'none'
            && data.gifts
          ) {
            this.isShowDynamicEffectDialog = true;
            data.gifts.forEach((item) => {
              this.configurationData.packagePosition.forEach((el) => {
                if (Number(el.packageId) === Number(item.package_id)) {
                  for (let index = 0; index < item.num; index++) {
                    this.packageImgArr.push({
                      img: el.images,
                    });
                  }
                }
              });
            });
            for (let index = 0; index < this.packageImgArr.length; index++) {
              const item = this.packageImgArr[index];
              const img = new Image();
              img.src = item.img;
              const that = this;
              img.onload = function () {
                that.count = that.count + 1;
                if (that.count === that.packageImgArr.length) {
                  that.count = 0;
                  that.showImage = true;
                }
              };
            }
            return;
          }
          // 默认弹框
          this.isShow = true;
        } else {
          this.alert(response.data.msg || response.msg);
        }
      }
    },
    // 动效弹窗抽奖方法
    lotteryHandlerFunc(flag) {
      this.packageImgArr = [];
      this.onceOrtimesFlag = flag;
      this.showImage = false;
      this.doReward();
    },
    closeDialogBtnClick() {
      this.packageImgArr = [];
      this.showImage = false;
      this.isShowDynamicEffectDialog = false;
      this.onceOrtimesFlag = true;
    },
    reportFunc(key, obj) {
      console.log(this.actInfo.report_config);
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj || {},
        };
        this.reportClickRaw(params);
        console.log(`reportFunc  to key  ${key} report  data =`, params);
      }
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
